import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { FootballTeamCoach } from "../../../../../../commons/models/football/football-team-coach";
import { EnsueCollection } from "../../../../../../ensue-react-system/utilities/ensue-collection";
import { StatusEnum } from "../../../../../../commons/enums/status-enum";
import { manageFootballTeamService } from "../../../../../../commons";

export interface IManageTeamCoachsState {
  manageTeamCoachsList: EnsueCollection<FootballTeamCoach>;
  manageTeamCoachsListStatus: StatusEnum;
}

export interface IManageTeamCoachsOption {
  teamId: number;
  urlParams?: {
    page?: number;
    perPage?: number;
    sort?: string;
    sortOrder?: "DESC" | "ASC";
    name?: string;
  };
}

const initialState: IManageTeamCoachsState = {
  manageTeamCoachsList: new EnsueCollection<FootballTeamCoach>(),
  manageTeamCoachsListStatus: StatusEnum.Idle,
};

export const fetchManageTeamCoachList = createAsyncThunk(
  "manage/teamCoachList",
  async (options: IManageTeamCoachsOption, thunkAPI) => {
    try {
      const manageTeamCoachsList = await manageFootballTeamService.getTeamCoaches(options.teamId, options.urlParams);
      return manageTeamCoachsList;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const manageTeamCoachListSlice = createSlice({
  name: "teamCoachAdd",
  initialState: initialState,
  reducers: {
    cleanUpManageTeamCoachs(state) {
      state.manageTeamCoachsList = new EnsueCollection<FootballTeamCoach>();
      state.manageTeamCoachsListStatus = StatusEnum.Idle;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchManageTeamCoachList.pending, (state) => {
        state.manageTeamCoachsListStatus = StatusEnum.Loading;
      })
      .addCase(
        fetchManageTeamCoachList.fulfilled,
        (state, action: PayloadAction<EnsueCollection<FootballTeamCoach>>) => {
          state.manageTeamCoachsListStatus = StatusEnum.Succeeded;
          state.manageTeamCoachsList = action.payload;
        }
      )
      .addCase(fetchManageTeamCoachList.rejected, (state) => {
        state.manageTeamCoachsListStatus = StatusEnum.Failed;
      });
  },
});

export const { cleanUpManageTeamCoachs } = manageTeamCoachListSlice.actions;
export default manageTeamCoachListSlice.reducer;
